export default {"src":"/_next/static/media/arrow_back.f6083f5b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};